export default function createRequestQueue(limit = 4) {
  const pending = new Map();
  const waiting = [];
  let active = 0;

  function execute(job, onComplete) {
    active += 1;
    const finish = () => {
      pending.delete(job.key);
      active -= 1;
      onComplete();
    };
    Promise.resolve().then(() => (
      job.consumers.some((isCurrent) => isCurrent()) ? job.request() : undefined
    )).then(
      (result) => { finish(); job.resolve(result); },
      (error) => { finish(); job.reject(error); },
    );
  }

  function drain() {
    while (active < limit && waiting.length) {
      const job = waiting.shift();
      if (job.consumers.some((isCurrent) => isCurrent())) {
        execute(job, drain);
      } else {
        pending.delete(job.key);
        job.resolve(undefined);
      }
    }
  }

  return {
    run(key, request, isCurrent = () => true) {
      if (pending.has(key)) {
        const job = pending.get(key);
        job.consumers.push(isCurrent);
        return job.promise;
      }
      const job = { key, request, consumers: [isCurrent] };
      job.promise = new Promise((resolve, reject) => {
        job.resolve = resolve;
        job.reject = reject;
      });
      pending.set(key, job);
      waiting.push(job);
      drain();
      return job.promise;
    },
  };
}
